import bcrypt from 'bcryptjs';
import crypto from 'crypto-js';
import { THISISAS3CR3T, THISISNOTAS3CR3T } from './const';

export const nameMap = {
  f_desde: 'Desde',
  f_hasta: 'Hasta',
  f_ingreso: 'Fecha de ingreso',
  f_egreso: 'Fecha de egreso',
  f_inicio: 'Fecha de inicio',
  f_fin: 'Fecha de finalización',
  f_presentacion: 'Fecha de presentación',
  linkPublicacion: 'Link de la publicación',
  duracion: 'Duración',
  establecimiento: 'Establecimiento',
  homologado: 'Homologado',
  nroActoAdministrativo: 'N° de acto administrativo',
  institucion: 'Institución académica',
  institucionOrganizadora: 'Institución organizadora',
  matriculaHabilitante: 'Matrícula habilitante vigente',
  frecuenciaDeLaMateria: 'Frecuencia de la materia',
  cargaHoraria: 'Carga horaria de la materia',
  otroPuestoDocente: 'Otro puesto docente',
  asignatura: 'Asignatura',
  nivelEducativo: 'Nivel educativo',

  pais: 'País',
  nombre: 'Nombre',
  descripcion: 'Descripción',
  tipo: 'Tipo',
  documentoPath: 'Documentación a validar',
  documentoPath2: 'Certificación de funciones',

  cargo: 'Cargo',
  lugarTrabajo: 'Denominación del Empleador o Lugar',
  personalACargo: 'Cantidad de personal a cargo',
  descripcionTarea: 'Descripción de tareas y responsabilidades',
};

export const CVSeccionMap = {
  antecedentesAcademicos: {
    cv: 'antecedenteAcademicoCV',
    api: 'antecedenteAcademico',
    pk: 'idAntecedenteAcademico',
  },
  antecedentesLaborales: {
    cv: 'antecedenteLaboralCV',
    api: 'antecedenteLaboralCV',
    pk: 'idAntecedenteLaboralCv',
  },
  institucionales: {
    cv: 'antecedenteInstitucionalCV',
    api: 'antecedenteInstitucionalCV',
    pk: 'idAntecedenteInstitucional',
  },
  capacitacion: {
    cv: 'cursoCV',
    api: 'cursoCV',
    pk: 'idCursoCv',
  },
  publicaciones: {
    cv: 'publicacionCV',
    api: 'publicacion',
    pk: 'idPublicacionCv',
  },
  idiomas: {
    cv: 'idiomaExtranjeroCV',
    api: 'idiomaExtranjero',
    pk: 'idIdiomaExtranjero',
  },
  informaticos: {
    cv: 'conocimientoInformaticoCV',
    api: 'conocimientoInformaticoCV',
    pk: 'idConocimientoInformaticoCv',
  },
};

export const fixStructure = (items, pk) => {
  if (items === null || typeof items === 'undefined') return [];

  const list = items.map((el) => {
    const newEl = {
      ...el,
      id: el[pk],
    };
    return newEl;
  });
  return list;
};

/**
 * Toma un arreglo y lo normaliza, utilizando como clave el  valor id de cada elemento contenido en el arreglo
 * @param {Array} items
 * @param {string} id
 */
export const normalizeStructure = (items, id) => {
  return items.reduce((acum, cur) => {
    let newCur = { ...cur, id: cur[id] };
    return {
      ...acum,
      [cur[id]]: newCur,
    };
  }, {});
};

export const isElementXPercentInViewport = function (el, percentVisible) {
  let rect = el.getBoundingClientRect(),
    windowHeight = window.innerHeight || document.documentElement.clientHeight;

  return !(
    Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100) <
      percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  );
};

export const parseISOString = (s) => {
  let b = s.split(/\D+/);
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
};

//TODO: Add funcion unhash

export const desencriptar = (password) => {
  // decode the password LENGTH 32
  const resultado = crypto.AES.decrypt(password, crypto.enc.Utf8.parse(THISISAS3CR3T), {
    mode: crypto.mode.ECB,
  }).toString(crypto.enc.Utf8);
  return resultado;
};

// TODO: Add funcion hash
export const encriptar = (password) => {
  const resultado = bcrypt.hashSync(THISISNOTAS3CR3T + password, 10);
  return resultado;
};
